(function () { 
   function findNearestNonAbsoluteEl(myElement) {
   let currentElement = myElement
     let nearestParent = null

     while (currentElement && currentElement !== document.body) {
       let parent = currentElement.parentElement
       if (parent) {
        let computedStyle = getComputedStyle(parent)
        if (computedStyle.position !== 'absolute') {
           nearestParent = parent
           break
         }
       }
       currentElement = parent
     }

     return nearestParent
   }

   document.addEventListener('DOMContentLoaded', function () {
     document.querySelectorAll('video:not([controls])').forEach(function (video) {
     const videoContainer = findNearestNonAbsoluteEl(video)

       videoContainer.classList.add('patrol-video')
       videoContainer.insertAdjacentHTML(
         'beforeend',
         '<button class="patrol-video__button" aria-pressed="false" aria-label="Pause video" type="button"><svg class="patrol-video__icon patrol-video__icon-play"xmlns="http://www.w3.org/2000/svg"viewBox="0 0 140 140"><title>Play icon</title><path fill-rule="evenodd" clip-rule="evenodd" fill="white" d="M70 140L70 140c-38.7 0-70-31.3-70-70l0 0C0 31.3 31.3 0 70 0l0 0c38.7 0 70 31.3 70 70l0 0C140 108.7 108.7 140 70 140z"/><polygon fill-rule="evenodd" clip-rule="evenodd" points="57 50.9 57 89.4 88.5 70.2 "/></svg><svg class="patrol-video__icon patrol-video__icon-pause"xmlns="http://www.w3.org/2000/svg"viewBox="0 0 140 140"><title>Pause icon</title><path fill-rule="evenodd" clip-rule="evenodd" fill="white" d="M70 140L70 140c-38.7 0-70-31.3-70-70v0C0 31.3 31.3 0 70 0h0c38.7 0 70 31.3 70 70v0C140 108.7 108.7 140 70 140z"/><rect fill-rule="evenodd" clip-rule="evenodd" x="56" y="50.8" class="st1" width="8.8" height="38.5"/><rect fill-rule="evenodd" clip-rule="evenodd" x="75.2" y="50.8" class="st1" width="8.8" height="38.5"/></svg></button>'
       )

       video.classList.add('patrol-loaded')

       const playPauseBtn = videoContainer.querySelector('.patrol-video__button')
       const playIcon = videoContainer.querySelector('.patrol-video__icon-play')
       const pauseIcon = videoContainer.querySelector('.patrol-video__icon-pause')

       playPauseBtn.addEventListener('click', function (e) {
         e.preventDefault()

         if (video.paused === true) {
           video.play()
         } else {
           video.pause()
         }
       })

       video.addEventListener('play', function () {
         video.setAttribute('data-state', 'play')
         video.setAttribute('data-state-reload', 'false')

         videoContainer.setAttribute('data-state', 'play')

         playIcon.setAttribute('aria-hidden', 'true')
         pauseIcon.setAttribute('aria-hidden', 'false')

         playPauseBtn.setAttribute('aria-label', 'Pause video')
         playPauseBtn.setAttribute('aria-pressed', 'false')
         playPauseBtn.setAttribute('data-button-state', 'play')
         playPauseBtn.setAttribute('data-button-state-reload', 'false')

         document.dispatchEvent(new CustomEvent('patrol:video-play'))
       })

       video.addEventListener('pause', function () {
         video.setAttribute('data-state', 'pause')

         videoContainer.setAttribute('data-state', 'pause')

         playIcon.setAttribute('aria-hidden', 'false')
         pauseIcon.setAttribute('aria-hidden', 'true')

         playPauseBtn.setAttribute('aria-label', 'Play video')
         playPauseBtn.setAttribute('aria-pressed', 'true')
         playPauseBtn.setAttribute('data-button-state', 'pause')

         document.dispatchEvent(new CustomEvent('patrol:video-pause'))
       })

       video.addEventListener('ended', function () {
         video.setAttribute('data-state', 'pause')
         video.setAttribute('data-state-reload', 'true')

         playPauseBtn.setAttribute('aria-pressed', 'true')
         playPauseBtn.setAttribute('data-button-state', 'pause')
         playPauseBtn.setAttribute('data-button-state-reload', 'true')
       })
     })
   })
 })()
